import { Component, computed, inject, signal } from '@angular/core';
import { BaseModalComponent } from "../../../../../../core/components/modals/base-modal/base-modal.component";
import { CopyPriceLevelConfigParams, PriceLevelConfigCopyDialogData } from "./types/price-level-config-copy.types";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { priceLevelConfigCopyModalName } from "./configs/price-level-config-copy-config";
import { MatButton } from "@angular/material/button";
import {
  CustomMatSelectComponent
} from "../../../../../../shared/components/ui/custom-mat-select/custom-mat-select.component";
import { PriceLevelConfigCopyService } from "./services/price-level-config-copy.service";
import { LoaderComponent } from "../../../../../../shared/components/loader/loader.component";

@Component({
  selector: 'app-price-level-config-copy-modal',
  imports: [
    BaseModalComponent,
    MatButton,
    CustomMatSelectComponent,
    LoaderComponent
  ],
  templateUrl: './price-level-config-copy-modal.component.html',
  styleUrl: './price-level-config-copy-modal.component.scss'
})
export class PriceLevelConfigCopyModalComponent extends BaseModalComponent {
  private priceLevelConfigCopyDialogData = inject<PriceLevelConfigCopyDialogData>(MAT_DIALOG_DATA);
  private priceLevelConfigCopyService: PriceLevelConfigCopyService = inject(PriceLevelConfigCopyService);

  public selectedArticleId = signal<string>('');
  public articleSelectData = computed(() => this.priceLevelConfigCopyDialogData.articleSelectData);
  public titleModal = computed(() => `Создать копию №${this.priceLevelConfigCopyDialogData.copyId}`);

  public override ngOnInit(): void {
    super.ngOnInit();
    this.modalStatesService.openModal(priceLevelConfigCopyModalName);
  }

  public override ngOnDestroy(): void {
    super.ngOnDestroy();
    this.modalStatesService.closeModal(priceLevelConfigCopyModalName);
  }

  public handleSelectChange(value: string): void {
    this.selectedArticleId.set(value);
  }

  public async confirmCopy(): Promise<void> {
    this.loadingService.setIsLoadingState(true);
    const params: CopyPriceLevelConfigParams = {
      copyId: this.priceLevelConfigCopyDialogData.copyId,
      newArticle: this.selectedArticleId()
    };

    await this.priceLevelConfigCopyService.copyPriceLevelConfig(params)
      .then(() => this.closeDialog('success'))
      .finally(() => this.loadingService.setIsLoadingState(false));
  }
}
